import { motion } from "framer-motion";
import { useEffect, useRef } from "react";

import { BreakoutSessionsDrawer } from "@/features/breakout-sessions/components/breakout-sessions-drawer";
import { ExtendSessionDrawer } from "@/features/extend-session/components/extend-session-drawer";
import { SessionSettingsDrawer } from "@/features/extend-session/components/session-settings-drawer";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { cn } from "@/lib/utils";

import { DrawerNavigation } from "./drawer-navigation";

export function ModerationDrawer() {
  const isOpen = useVidyoStore((s) => s.moderationDrawer.isOpen);
  const closeModerationDrawer = useVidyoStore((s) => s.moderationDrawer.close);
  const activeTab = useVidyoStore((store) => store.moderationDrawer.activeTab);
  const drawerRef = useRef<HTMLDivElement>(null);

  // Close moderation drawer when component unmounts
  useEffect(() => {
    return () => {
      closeModerationDrawer();
    };
  }, [closeModerationDrawer]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      closeModerationDrawer();
    }
  };

  return (
    <motion.div
      ref={drawerRef}
      className={cn(
        "fixed bottom-[var(--action-bar-height)] right-3 top-4 z-10 h-auto w-80",
        "rounded-md border border-border bg-background ring-4 ring-card",
      )}
      initial={{ x: 320 + 12 }}
      animate={{ x: isOpen ? 0 : 320 + 16 }} // 16 is the right-4 on this component
      transition={{ duration: 0.4, ease: "easeInOut" }}
      role="dialog"
      aria-hidden={!isOpen}
      aria-labelledby="moderation-drawer-title"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      //@ts-expect-error inert is supported only react 19+
      inert={!isOpen ? "" : undefined}
    >
      {activeTab === "extend-session" && <ExtendSessionDrawer />}
      {activeTab === "session-settings" && <SessionSettingsDrawer />}
      {activeTab === "breakout-sessions" && <BreakoutSessionsDrawer />}
      {!activeTab && <DrawerNavigation />}
    </motion.div>
  );
}
